import { cloneElement, forwardRef, useImperativeHandle } from 'react';

import useLazy from '@/hooks/useLazy';
import dynamic from 'next/dynamic';

const DynamicSupportPopup = dynamic(() => import('./content'), { ssr: false });

const SupportPopup = forwardRef(({ children, ...rest }: any, ref) => {
  const { show, hide, visible, loaded } = useLazy();

  useImperativeHandle(ref, () => {
    return {
      show,
      hide
    };
  });

  return (
    <>
      {!!children &&
        cloneElement(children, {
          onClick: show
        })}
      {loaded && <DynamicSupportPopup {...rest} visible={visible} onCancel={hide} />}
    </>
  );
});
export default SupportPopup;
